module.exports = __webpack_public_path__ + "static/img/didi.41fd66f0.jpg";